
export default {
  name: 'LinkTreeItem',

  props: {
    link: {
      type: Object,
      default: () => ({})
    },

    centered: {
      type: Boolean,
      default: false
    }
  }
}
